// DailyLearning.jsx

import React, { useEffect, useState } from "react";

import {
  saveTaskToFirebase,
  getTodayTasks,
  deleteTaskFromFirebase,
  updateTaskInFirebase
} from "../../firebase";

// ---------------- INITIAL DROPDOWN DATA ----------------

const initialDropdownData = {

  Udemy: {

    AI: [
      "ChatGPT",
      "Prompt Engineering",
      "AI Tools"
    ],

    "Logical PGMS": [
      "FinalTouch",
      "Udemy-Logicals"
    ]
  },

  "ReactJS Learn": {

    SoftwareSchools: [
      "React Hooks",
      "Redux",
      "React Router"
    ],

    Other: [
      "Context API",
      "Axios"
    ]
  },

  Java: {

    "Core Java": [
      "Oops",
      "Collections",
      "Streams"
    ],

    Spring: [
      "IOC",
      "Beans"
    ],

    "Spring Boot": [
      "Rest API",
      "Security"
    ],

    Hibernate: [
      "Mappings",
      "JPA"
    ],

    Microservices: [
      "Eureka",
      "Feign Client"
    ]
  },

  SQL: {

    PLSQL: [
      "Procedures",
      "Functions",
      "Triggers"
    ],

    Joins: [
      "Inner Join",
      "Left Join",
      "Right Join"
    ]
  }
};

const DailyLearning = () => {

  // ---------------- STATE ----------------

  const [tasks, setTasks] = useState([]);

  const [dropdownData, setDropdownData] =
    useState(initialDropdownData);

  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    topic: "",
    duration: ""
  });

  const [editId, setEditId] = useState(null);

  // ---------------- NEW INPUT STATES ----------------

  const [newCategory, setNewCategory] =
    useState("");

  const [newSubCategory, setNewSubCategory] =
    useState("");

  const [newTopic, setNewTopic] =
    useState("");

  // ---------------- LOAD TASKS ----------------

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {

    const data = await getTodayTasks();

    setTasks(data || []);
  };

  // ---------------- HANDLE CHANGE ----------------

  const handleChange = (e) => {

    const { name, value } = e.target;

    // CATEGORY CHANGE

    if (name === "category") {

      setFormData({
        category: value,
        subCategory: "",
        topic: "",
        duration: ""
      });

      return;
    }

    // SUB CATEGORY CHANGE

    if (name === "subCategory") {

      setFormData({
        ...formData,
        subCategory: value,
        topic: ""
      });

      return;
    }

    // OTHER FIELDS

    setFormData({
      ...formData,
      [name]: value
    });
  };

  // ---------------- ADD CATEGORY ----------------

  const handleAddCategory = () => {

    if (!newCategory) return;

    setDropdownData({
      ...dropdownData,

      [newCategory]: {}
    });

    setNewCategory("");
  };

  // ---------------- ADD SUBCATEGORY ----------------

  const handleAddSubCategory = () => {

    if (
      !formData.category ||
      !newSubCategory
    ) return;

    setDropdownData({
      ...dropdownData,

      [formData.category]: {

        ...dropdownData[formData.category],

        [newSubCategory]: []
      }
    });

    setNewSubCategory("");
  };

  // ---------------- ADD TOPIC ----------------

  const handleAddTopic = () => {

    if (
      !formData.category ||
      !formData.subCategory ||
      !newTopic
    ) return;

    setDropdownData({
      ...dropdownData,

      [formData.category]: {

        ...dropdownData[formData.category],

        [formData.subCategory]: [

          ...dropdownData[
            formData.category
          ][
            formData.subCategory
          ],

          newTopic
        ]
      }
    });

    setNewTopic("");
  };

  // ---------------- SAVE / UPDATE ----------------

  const handleSave = async () => {

    if (
      !formData.category ||
      !formData.subCategory ||
      !formData.topic ||
      !formData.duration
    ) {

      alert("Please fill all fields");

      return;
    }

    try {

      // UPDATE

      if (editId) {

        const updatedTask = {
          ...formData,
          id: editId
        };

        await updateTaskInFirebase(updatedTask);

        alert("Task Updated");

      } else {

        // CREATE

        await saveTaskToFirebase(formData);

        alert("Task Saved");
      }

      // RELOAD

      loadTasks();

      // CLEAR FORM

      setFormData({
        category: "",
        subCategory: "",
        topic: "",
        duration: ""
      });

      setEditId(null);

    } catch (err) {

      console.error(err);
    }
  };

  // ---------------- DELETE ----------------

  const handleDelete = async (id) => {

    try {

      await deleteTaskFromFirebase(id);

      alert("Task Deleted");

      loadTasks();

    } catch (err) {

      console.error(err);
    }
  };

  // ---------------- EDIT ----------------

  const handleEdit = (task) => {

    setFormData({
      category: task.category,
      subCategory: task.subCategory,
      topic: task.topic,
      duration: task.duration
    });

    setEditId(task.id);
  };

  // ---------------- UI ----------------

  return (

    <div
      style={{
        padding: "15px",
        background: "#f5f7fb",
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box"
      }}
    >

      <h1
        style={{
          marginBottom: "20px",
          fontSize: "28px"
        }}
      >
        Daily Learning Dashboard
      </h1>

      {/* ADD NEW DROPDOWN VALUES */}

      <div style={cardStyle}>

        <h2>Add New Dropdown Values</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(250px,1fr))",
            gap: "15px",
            marginTop: "20px"
          }}
        >

          {/* CATEGORY */}

          <div>

            <input
              type="text"
              placeholder="New Category"
              value={newCategory}
              onChange={(e) =>
                setNewCategory(e.target.value)
              }
              style={inputStyle}
            />

            <button
              onClick={handleAddCategory}
              style={addBtn}
            >
              Add Category
            </button>

          </div>

          {/* SUB CATEGORY */}

          <div>

            <input
              type="text"
              placeholder="New SubCategory"
              value={newSubCategory}
              onChange={(e) =>
                setNewSubCategory(e.target.value)
              }
              style={inputStyle}
            />

            <button
              onClick={handleAddSubCategory}
              style={addBtn}
            >
              Add SubCategory
            </button>

          </div>

          {/* TOPIC */}

          <div>

            <input
              type="text"
              placeholder="New Topic"
              value={newTopic}
              onChange={(e) =>
                setNewTopic(e.target.value)
              }
              style={inputStyle}
            />

            <button
              onClick={handleAddTopic}
              style={addBtn}
            >
              Add Topic
            </button>

          </div>

        </div>

      </div>

      {/* FORM */}

      <div style={cardStyle}>

        <h2>Add / Update Learning Task</h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fit,minmax(220px,1fr))",
            gap: "15px",
            marginTop: "20px"
          }}
        >

          {/* CATEGORY */}

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            style={inputStyle}
          >

            <option value="">
              Select Category
            </option>

            {
              Object.keys(dropdownData).map((category) => (

                <option
                  key={category}
                  value={category}
                >
                  {category}
                </option>

              ))
            }

          </select>

          {/* SUB CATEGORY */}

          <select
            name="subCategory"
            value={formData.subCategory}
            onChange={handleChange}
            style={inputStyle}
          >

            <option value="">
              Select SubCategory
            </option>

            {
              formData.category &&

              Object.keys(
                dropdownData[
                  formData.category
                ]
              ).map((sub) => (

                <option
                  key={sub}
                  value={sub}
                >
                  {sub}
                </option>

              ))
            }

          </select>

          {/* TOPIC */}

          <select
            name="topic"
            value={formData.topic}
            onChange={handleChange}
            style={inputStyle}
          >

            <option value="">
              Select Topic
            </option>

            {
              formData.category &&
              formData.subCategory &&

              dropdownData[
                formData.category
              ][
                formData.subCategory
              ].map((topic) => (

                <option
                  key={topic}
                  value={topic}
                >
                  {topic}
                </option>

              ))
            }

          </select>

          {/* DURATION */}

          <input
            type="number"
            name="duration"
            placeholder="Hours"
            value={formData.duration}
            onChange={handleChange}
            style={inputStyle}
          />

          {/* SAVE BUTTON */}

          <button
            onClick={handleSave}
            style={saveBtn}
          >

            {
              editId
                ? "Update Task"
                : "Save Task"
            }

          </button>

        </div>

      </div>

      {/* TABLE */}

      <div
        style={{
          ...cardStyle,
          overflowX: "auto"
        }}
      >

        <h2>
          Today's Learning Tasks
        </h2>

        <table
          width="100%"
          cellPadding="12"
          style={{
            minWidth: "700px",
            borderCollapse: "collapse",
            marginTop: "20px"
          }}
        >

          <thead>

            <tr
              style={{
                background: "#ecebff"
              }}
            >

              <th>#</th>
              <th>Category</th>
              <th>SubCategory</th>
              <th>Topic</th>
              <th>Duration</th>
              <th>Actions</th>

            </tr>

          </thead>

          <tbody>

            {
              tasks.length > 0 ? (

                tasks.map((task, index) => (

                  <tr
                    key={task.id}
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #ddd"
                    }}
                  >

                    <td>{index + 1}</td>

                    <td>{task.category}</td>

                    <td>{task.subCategory}</td>

                    <td>{task.topic}</td>

                    <td>{task.duration} hrs</td>

                    <td>

                      <button
                        onClick={() =>
                          handleEdit(task)
                        }
                        style={editBtn}
                      >
                        Edit
                      </button>

                      <button
                        onClick={() =>
                          handleDelete(task.id)
                        }
                        style={deleteBtn}
                      >
                        Delete
                      </button>

                    </td>

                  </tr>

                ))

              ) : (

                <tr>

                  <td
                    colSpan="6"
                    style={{
                      padding: "20px",
                      textAlign: "center"
                    }}
                  >

                    No Tasks Available

                  </td>

                </tr>
              )
            }

          </tbody>

        </table>

      </div>

    </div>
  );
};

// ---------------- STYLES ----------------

const cardStyle = {
  background: "#fff",
  padding: "15px",
  borderRadius: "12px",
  marginBottom: "30px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  outline: "none",
  boxSizing: "border-box"
};

const saveBtn = {
  background: "#6c63ff",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  padding: "12px",
  minHeight: "45px"
};

const addBtn = {
  marginTop: "10px",
  width: "100%",
  padding: "10px",
  background: "#6c63ff",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};

const editBtn = {
  background: "#4caf50",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: "6px",
  cursor: "pointer",
  marginRight: "10px",
  marginBottom: "5px"
};

const deleteBtn = {
  background: "#f44336",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "5px"
};

export default DailyLearning;